import { Routes, Route } from 'react-router';

import EmailDraft from '@/components/organisms/Integrations/Email/EmailDraft';
import EmailList from '@/components/organisms/Integrations/Email/EmailList';
import Integration from '@/components/pages/Integration/Integration';
import Integrations from '@/components/pages/Integrations/Integrations';
import Layout from '@/components/templates/Layout';
import PermissionsWrapper from '@/components/templates/PermissionsWrapper';

const IntegrationRouter: React.FC = () => {
  return (
    <Layout>
      <PermissionsWrapper module="integrations">
        <Routes>
          <Route path="/email" element={<EmailList />} />
          <Route path="/email/draft" element={<EmailDraft />} />
          <Route path="/:integrationId" element={<Integration />} />
          <Route path="/" element={<Integrations />} />
        </Routes>
      </PermissionsWrapper>
    </Layout>
  );
};
IntegrationRouter.displayName = 'IntegrationRouter';

export default IntegrationRouter;
